import { getMomentTz, TimeService } from "@dexteel/mesf-core";
import type React from "react";
import { EventSegment } from "../models/Event";
import { billetStatus } from "../shared/billetStatus";
import { eventTypes, productionTypes } from "../shared/eventTypes";

const moment = getMomentTz();

export const getEventStyle = (
	segment: EventSegment,
	hoveredBilletStatusCode: string | null,
	swapProductionColors: boolean,
): React.CSSProperties => {
	const { segStart, segEnd, isStart, isEnd, event } = segment;

	const eventType = eventTypes.find((t) => t.code === event.EventTypeCode);
	const productionType = productionTypes.find(
		(t) => t.code === event.StatusCode,
	);
	const billetType = billetStatus.find(
		(t) => t.code === event.BilletsStatusCode,
	);

	const isHoveredBillet =
		hoveredBilletStatusCode &&
		event.BilletsStatusCode === hoveredBilletStatusCode;

	const backgroundColor =
		event.EventTypeCode === "P"
			? isHoveredBillet
				? (billetType?.backgroundColor ?? productionType?.backgroundColor)
				: swapProductionColors
					? billetType?.backgroundColor
					: productionType?.backgroundColor
			: eventType?.backgroundColor;
	const borderColor =
		event.EventTypeCode === "P"
			? productionType?.borderColor
			: eventType?.borderColor;
	const color =
		event.EventTypeCode === "P"
			? isHoveredBillet
				? "#404040"
				: (productionType?.textColor ?? eventType?.textColor)
			: "";

	const baseStyle: React.CSSProperties = {
		position: "relative",
		overflow: "hidden",
		cursor: "default",
		borderRadius: "4px",
		padding: "2px 6px",
		marginBottom: "2px",
		fontSize: "0.75rem",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		backgroundColor,
		borderLeft:
			event.EventTypeCode === "P"
				? swapProductionColors
					? `30px solid ${productionType?.backgroundColor}`
					: `30px solid ${billetType?.backgroundColor}`
				: `3px solid ${borderColor}`,
		borderRight: `3px solid ${borderColor}`,
		color,
	};

	let width = 100;
	let marginLeft = 0;

	const serverTz = TimeService.getInstance().getServerTimeZone();
	const momentStart = moment.tz(segStart, serverTz);
	const momentEnd = moment.tz(segEnd, serverTz);

	if (isStart && isEnd) {
		const startPercent =
			((momentStart.hour() * 60 + momentStart.minute()) / (24 * 60)) * 100;
		const durationMinutes =
			(momentEnd.valueOf() - momentStart.valueOf()) / (1000 * 60);
		const durationPercent = Math.min(
			(durationMinutes / (24 * 60)) * 100,
			100 - startPercent,
		);
		marginLeft = startPercent;
		width = Math.max(durationPercent, 5);
	} else if (isStart) {
		const startPercent =
			((momentStart.hour() * 60 + momentStart.minute()) / (24 * 60)) * 100;
		marginLeft = startPercent;
		width = 100 - startPercent;
	} else if (isEnd) {
		const endPercent =
			((momentEnd.hour() * 60 + momentEnd.minute()) / (24 * 60)) * 100;
		marginLeft = 0;
		width = Math.max(endPercent, 5);
	} else {
		marginLeft = 0;
		width = 100;
	}

	return {
		...baseStyle,
		width: `${width}%`,
		marginLeft: `${marginLeft}%`,
	};
};
